import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonIcon,
} from "@ionic/react";
import { logInOutline, logOutOutline } from "ionicons/icons";
import { useUserDetails } from "../hooks/useUserDetails";
import { useMyDetails } from "../hooks/useMyDetails";
import { PRESETS_ADMIN_ENABLED } from "../config";
import { useAutoSignInStatus } from "../hooks/useAutoSignInStatus";

import "./AppHeader.css";

const AppHeader: React.FC = () => {
  const { instance, accounts, logout } = useUserDetails();
  const autoSignInStatus = useAutoSignInStatus();
  const manualSignInEnabled =
    autoSignInStatus === "failed" || autoSignInStatus === "skipped";
  // Use the same gate as the Presets pages so the nav link only appears for
  // staff site-admins. We accept the small extra `/my/details/` call on every
  // header render because TanStack Query caches it for 30 minutes (see
  // useMyDetails staleTime).
  const { hasAdminAccess } = useMyDetails();

  const account = accounts[0];

  return (
    <IonHeader className="app-header">
      <IonToolbar>
        <IonButtons slot="start">
          <IonButton routerLink="/groups" title="Pymble Group Manager">
            <div className="plc-horizontal-logo"></div>
          </IonButton>
        </IonButtons>
        <IonTitle>Pymble Group Manager</IonTitle>
        <IonButtons slot="end">
          {PRESETS_ADMIN_ENABLED && hasAdminAccess && (
            <IonButton routerLink="/presets" fill="clear">
              Presets
            </IonButton>
          )}
          {account && (
            <>
              <span className="user-name">
                {account.name || account.username}
              </span>
              <IonButton
                fill="clear"
                aria-label="Sign out"
                onClick={() => void logout()}
              >
                <IonIcon slot="icon-only" icon={logOutOutline} />
              </IonButton>
            </>
          )}
          {!account && (
            <IonButton
              fill="clear"
              aria-label="Sign in"
              disabled={!manualSignInEnabled}
              onClick={
                manualSignInEnabled
                  ? () => void instance.loginRedirect()
                  : undefined
              }
            >
              <IonIcon slot="icon-only" icon={logInOutline} />
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default AppHeader;
